// extracted by mini-css-extract-plugin
export default {"container":"container-lvmnZ","skeleton":"skeleton-LQWRN","placeholderImage":"placeholderImage-dC5G3","gallery":"gallery-rqHYr","fullscreen":"fullscreen-OpTCO"};